<template>
  <div class="manage-match-list">
    <div class="invite-list" v-if="inviteList.length > 0">
      <div class="item" v-for="item in inviteList" :key="item.id">
        <div class="name overflow-text">{{ item.chineseName }}</div>
        <div class="but" @click="accepted(item.chineseName,item.id)">接受邀请</div>
      </div>
    </div>
    <div style="height: 3px;"></div>
    <div class="match-list" v-if="list.length > 0">
      <div class="match" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
        <div class="row">
          <van-image style="border-radius: 4px; width: 50px; height: 50px; overflow: hidden"
            :src="imageView(item.icon, 100, 100)"></van-image>
          <div class="info">{{ item.chineseName }}</div>
          <img src="../../assets/grey-right.png" style="width: 13px; height: 13px;">
        </div>
        <div style="height: 18px; box-sizing: border-box; border-bottom: 1px #F6F6F8 solid;"></div>
      </div>
    </div>
    <van-empty description="暂无数据" v-else />
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage, Empty, Dialog } from 'vant'
Vue.use(VanImage).use(Empty).use(Dialog)
// import { adminGetBMUnionMatchList } from '@/api/match.js'
import {
  getMerchantMatchUnionListByUser,
  getUnionMatchManagerInviteList,
  acceptUnionMatchManagerInvite
} from '@/api/match'
import { QNImageUtil } from '@/utils'

export default {
  data() {
    return {
      list: [],
      merchantId: '',
      inviteList: []
    }
  },
  mounted() {
    this.merchantId = this.$route.params.merchantId
    this.getMerchantMatchUnionListByUser()
    this.getUnionMatchManagerInviteList()
  },
  methods: {
    goDetail(item) {
      this.$router.push('/match-manage/match-detail/' + item.id)
    },
    getUnionMatchManagerInviteList() {
      getUnionMatchManagerInviteList().then(res => {
        console.log(res);
        this.inviteList = res.data.list
      })
    },
    getMerchantMatchUnionListByUser() {
      const params = {
        merchantId: this.merchantId,
        pageSize: 999,
        pageNum: 1
      }
      getMerchantMatchUnionListByUser(params).then(res => {
        const data = res.data
        this.list = data.list
      })
    },
    imageView(img, w, h) {
      return QNImageUtil.imageView(img, w, h)
    },
    accepted(name,id) {
      Dialog.confirm({
        title: '系统提示',
        message: `确认需要管理[${name}]`,
      }).then(() => {
        acceptUnionMatchManagerInvite({ id }).then(() => {
          this.getMerchantMatchUnionListByUser()
          this.getUnionMatchManagerInviteList()
        })
        // on close
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.manage-match-list {
  min-height: 100vh;
  background-color: #F6F6F8;

  .invite-list {
    .item {
      background-color: #F6F6F8;
      padding: 8px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .name {
        font-size: 14px;
        font-weight: 500;
        padding-right: 12px;
      }

      .but {
        min-width: 88px;
        font-size: 12px;
        color: #1565FC;
        border-radius: 12px;
        border: 1px solid #1565FC;
        text-align: center;
        box-sizing: border-box;
        padding: 4px 0;
      }
    }
  }

  .match-list {
    background-color: #FFFFFF;

    .match {
      padding: 18px 12px 0 12px;

      .row {
        display: flex;
        align-items: center;

        .info {
          width: calc(100% - 97px);
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin: 0 26px 0 8px;
          font-size: 15px;
          color: #191919;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
